<template>
  <div>
    <BButton
      ref="buttonRef"
      class="badge badge-pill circle"
      variant="primary"
      type="button"
    >
      ?
    </BButton>

    <BPopover
      :target="buttonEl"
      placement="top-start"
      teleport-to="body"
      triggers="hover focus"
      :boundary-padding="8"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="tipHtml"></div>
    </BPopover>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { BButton, BPopover } from "bootstrap-vue-next";

defineProps<{
  tipHtml: string;
}>();

const buttonRef = ref<InstanceType<typeof BButton> | null>(null);
const buttonEl = computed<HTMLElement | null>(
  () => buttonRef.value?.$el ?? null,
);

const focusButton = () => {
  buttonRef.value?.$el?.focus();
};

defineExpose({ focusButton });
</script>

<style scoped lang="scss">
@use "@/sass/components/HelpBadgeCircle.scss" as *;
</style>
